import moment, { Moment } from 'moment'

export function hasChildInAgeRange(
    children: { birthdate: string }[],
    ageMin: string,
    ageMax: string,
    today: Moment = moment()
): boolean {
    if (ageMin === '' && ageMax === '') return true

    const minMonths: number = ageMin === '' ? 0 : Number(ageMin) * 12
    const maxMonths: number = ageMax === '' ? Infinity : Number(ageMax) * 12

    return children.some(({ birthdate }) => {
        const birth: Moment = moment(birthdate, 'DD-MM-YYYY', true)
        if (!birth.isValid() || birth.isAfter(today)) return false

        const ageMonths: number = today.diff(birth, 'months')
        return ageMonths >= minMonths && ageMonths <= maxMonths
    })
}
